import React from "react";
import { Paper, IconButton, Typography, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import GradeOutlinedIcon from "@material-ui/icons/GradeOutlined";
import StarIcon from "@material-ui/icons/Star";
import TextField from "@material-ui/core/TextField";
import icon1 from "../../assets/images/estimates.svg";
import SelectEstimate from "../reusable-components/SelectEstimate";
import { DefaultButton } from "./UI/Buttons";
import ChipsArray from "../small-components/chips";
import { Link } from "react-router-dom";

export default function FilterList(props) {
  const { dataType = "", allTags } = props;

  const handleFavorite = (id, e) => {
    props.handleFavorite(id, e);
  };

  const useStyles = makeStyles({
    filter_icon_outer: {
      "& .defaut-black": {
        display: "block",
      },
      "& .template_pink": {
        display: "none",
      },
      "&:hover": {
        "& .defaut-black": {
          display: "none",
        },
        "& .template_pink": {
          display: "block",
        },
      },
    },
  });
  const classes = useStyles();
  const optionAction = (e, id) => {
    props.optionChange(e, id);
  };
  const saveTamplate = (id) => {
    props.templateId(id);
  };
  const items = (props.items || []).filter(
    (d) => d.archive !== "true" && d.projectName
  );
  if (items.length === 0) {
    return null;
  }
  return (
    <Grid container className="outer-box filter-temp-est ">
      {items.slice(6 * props.page - 6, 6 * props.page).map((curItem) => {
        const favorite =
          props.favoriteestimate &&
          props.favoriteestimate.find((item) => {
            return item && item.id === curItem.id;
          }) !== undefined;
        let tempDataType = dataType;
        let tempPlural = "s";
        let titleName = tempDataType;
        if (curItem.typeOf === "TIME BASED ESTIMATE") {
          tempDataType = "estimates-timebased";
          titleName = "estimates";
          tempPlural = "";
        }
        return (
          <Grid item className={props.classes.item} xs={12} key={curItem.id}>
            <Paper className={props.classes.innerItem} elevation={0}>
              <div
                className={`item-intro`}
                key="0"
              >
                <Typography variant="h6" key="t0">
                  {curItem.filterType === "task-based"
                    ? "TASK BASED "
                    : "TIME BASED "}
                  {titleName.toUpperCase()}
                </Typography>
                <Typography
                  variant="h5"
                  color="primary"
                  className={classes.contentOuter}
                  key="t1"
                >
                  <img src={icon1} alt="estimates"></img>
                  <Link
                    style={{ width: "100%" }}
                    to={{
                      pathname: `/${tempDataType}${tempDataType.endsWith("s") ? "" : tempPlural
                        }/${curItem.projectName}/${curItem.id}`,
                      state: {
                        key: curItem.id,
                      },
                    }}
                    onClick={() => { }}
                  >
                    <h3 className="filter-list-name"> {curItem.projectName} </h3>
                  </Link>
                </Typography>
                <div className="info" key="t2">
                  <ChipsArray
                    key={curItem.id}
                    itemId={curItem.id}
                    tagsList={curItem.tags}
                    dataType={dataType}
                    refreshData={props.refreshData}
                    allTags={allTags}
                  ></ChipsArray>
                </div>
              </div>

              <div className="item-option" key="1">
                <div className="option-outer" key="d0">
                  {curItem.modified ? (
                    <div className="text-wrapper" key="1">
                      <Typography variant="body1" color="textSecondary">
                        Last modified
                      </Typography>
                      <Typography variant="subtitle2" color="textSecondary">
                        {curItem.modified}{" "}
                      </Typography>
                    </div>
                  ) : (
                    <div className="text-wrapper" key="1"></div>
                  )}

                  <div className="featured-icon" key="2">
                    <IconButton
                      aria-label="featured"
                      onClick={() =>
                        handleFavorite(curItem.id, curItem.favorite)
                      }
                    >
                      {favorite === true ? (
                        <StarIcon htmlColor="#2ab7ca" />
                      ) : (
                        <GradeOutlinedIcon htmlColor="#000" />
                      )}
                    </IconButton>
                  </div>
                  <div
                    className="select-box"
                    key="3"
                    style={{
                      display: "inline-block",
                      maxWidth: "35px",
                      position: "relative",
                      top: "3px",
                    }}
                  >
                    <SelectEstimate
                      list={props.list}
                      name={curItem.projectName}
                      optionAction={optionAction}
                      id={curItem.id}
                      placement="bottom"
                    />
                  </div>
                </div>
                <div className="buttonOuter" key="2">
                  <DefaultButton
                    onClick={() => saveTamplate(curItem.id)}
                    style={{ backgroundColor: "#084d4f", color: "#ffffff" }}
                  >
                    Save as a Template
                  </DefaultButton>
                </div>
              </div>
            </Paper>
          </Grid>
        );
      })}
    </Grid>
  );
}
